(() => {
  const stateKey = Symbol.for('mw-stkt.calculator.state');

  const initializeCalculators = (root = document) => {
    const calculators = root.matches?.('[data-mw-stkt-calculator]')
      ? [root]
      : Array.from(root.querySelectorAll?.('[data-mw-stkt-calculator]') || []);

    calculators.forEach((calculator) => {
      if (calculator.dataset.calculatorReady === 'true') return;

      const fields = Array.from(calculator.querySelectorAll('[data-mw-stkt-calculator-field]'));
      const result = calculator.querySelector('[data-mw-stkt-calculator-result]');
      const summary = calculator.querySelector('[data-mw-stkt-calculator-summary]');
      const transfer = calculator.querySelector('[data-mw-stkt-calculator-transfer]');
      const faqItems = Array.from(calculator.querySelectorAll('[data-mw-stkt-faq-item]'));

      const numericValues = () =>
        Object.fromEntries(
          fields.map((field) => [field.dataset.mwStktCalculatorField, Number.parseFloat(field.value)])
        );

      const displayValues = () => {
        const current = numericValues();
        return {
          'room-size': `${current['room-size']} m²`,
          'room-height': `${current['room-height'].toFixed(1)} m`,
          'window-size': `${current['window-size']} m²`,
          persons: `${current.persons} ${current.persons === 1 ? 'Person' : 'Personen'}`,
        };
      };

      const coolingDemand = () => {
        const current = numericValues();
        return (
          current['room-size'] * current['room-height'] * 0.0335 +
          current['window-size'] * 0.15 +
          current.persons * 0.12
        );
      };

      const formattedCoolingDemand = () =>
        (Math.round((coolingDemand() + Number.EPSILON) * 100) / 100).toFixed(2);

      const resultText = () => `ca. ${formattedCoolingDemand()} kW`;

      const summaryText = () => {
        const current = displayValues();
        return `${current['room-size']} · ${current['room-height']} Raumhöhe · ${current['window-size']} Fenster · ${current.persons}`;
      };

      const render = () => {
        const current = displayValues();

        fields.forEach((field) => {
          const key = field.dataset.mwStktCalculatorField;
          const valueOutput = calculator.querySelector(`[data-mw-stkt-calculator-value="${key}"]`);
          const minimum = Number.parseFloat(field.min);
          const maximum = Number.parseFloat(field.max);
          const progress = ((Number.parseFloat(field.value) - minimum) / (maximum - minimum)) * 100;

          if (valueOutput) valueOutput.textContent = current[key];
          field.setAttribute('aria-valuetext', current[key]);
          field.style.setProperty('--mw-stkt-range-progress', `${progress}%`);
        });

        if (result) result.textContent = resultText();
        if (summary) summary.textContent = summaryText();
      };

      fields.forEach((field) => field.addEventListener('input', render));
      render();

      transfer?.addEventListener('click', (event) => {
        const current = displayValues();
        const transferEvent = new CustomEvent('mw-stkt:calculator-transfer', {
          bubbles: false,
          cancelable: true,
          detail: {
            target: transfer.dataset.mwStktContactTarget || '#kontakt',
            values: {
              ...current,
              'cooling-demand': `${formattedCoolingDemand()} kW`,
            },
          },
        });

        if (!document.dispatchEvent(transferEvent)) event.preventDefault();
      });

      faqItems.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          faqItems.forEach((otherItem) => {
            if (otherItem !== item) otherItem.open = false;
          });
        });
      });

      calculator.dataset.calculatorReady = 'true';
    });
  };

  const existingState = document[stateKey];
  if (existingState) {
    existingState.initialize(document);
    return;
  }

  document[stateKey] = { initialize: initializeCalculators };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCalculators(), { once: true });
  } else {
    initializeCalculators();
  }

  document.addEventListener('shopify:section:load', (event) => initializeCalculators(event.target));
})();
